import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AddressEffects, AddressReducers } from "./";

@NgModule({
    imports: [CommonModule, StoreModule.forFeature("address", AddressReducers.reducer), EffectsModule.forFeature([AddressEffects])],
    providers: [AddressEffects],
})
export class AddressStoreModule {}
